import React from 'react'
import PropTypes from 'prop-types'
import styles from './styles'

export const Label = ({
  className,
  label,
  required,
  id,
  css,
  secondLabel,
  ...props
}) => {
  const inputId = id || props?.placeholder
  return (
    <div>
      {(label || required || secondLabel) && (
        <div css={styles.labelsContainer}>
          <label css={styles.label} htmlFor={inputId}>
            {label}
            {required && <span css={styles.required}>*</span>}
          </label>
          {secondLabel && <span css={styles.secondLabel}>{secondLabel}</span>}
        </div>
      )}
    </div>
  )
}

Label.propTypes = {
  className: PropTypes.string,
  label: PropTypes.string,
  required: PropTypes.bool,
  id: PropTypes.string,
  placeholder: PropTypes.string,
  css: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  secondLabel: PropTypes.shape({
    text: PropTypes.string,
    onClick: PropTypes.func,
  }),
  size: PropTypes.string,
}
